import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { get_city, get_state, get_country, get_profile } from "../../../api/ControllApi";
import { toast } from "react-toastify";
import { get_vendor_store, vendor_store, vendor_store_edit } from "../../../api/Role";
import { CircularProgress } from "@mui/material";
import { useUser } from "../../../context/LoginDetail";
import {
  GoogleMap,
  MarkerF,
  useJsApiLoader,
  Autocomplete as GMapAutocomplete,
} from "@react-google-maps/api";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  TextField as MuiTextField,
  Box,
  Typography,
} from "@mui/material";

function useDebounce(value, delay = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}

const GOOGLE_MAP_LIBRARIES = ["places"];

export default function MaterialVendorAddProperty() {
  const [hasStore, setHasStore] = useState(false);
  const navigate = useNavigate();
  const { user } = useUser();

  const [form, setForm] = useState({
    name: "",
    city: "",
    state: "",
    postal_code: "",
    phone: "",
    email: "",
    website: "",
    description: "",
    gst: "",
    pan: "",
    instagram: "",
    facebook: "",
    x: "",
    youtube: "",
    lat: "",
    lang: "",
    address: "",
    tin: "",
    fax: "",
    established: "",
    image: [],
    thumbnail: null,
    country_id: "",
    state_id: "",
    city_id: "",
  });

  const [countrySearch, setCountrySearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");

  const debouncedCountry = useDebounce(countrySearch, 400);
  const debouncedState = useDebounce(stateSearch, 400);
  const debouncedCity = useDebounce(citySearch, 400);

  // Debounce address input for geocoding as user types
  const debouncedAddress = useDebounce(form.address, 600);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const pinRef = useRef(null);
  const shadowRef = useRef(null);

  // Track whether last address change came from autocomplete/geocode (so we don't re-geocode)
  const addressFromMapRef = useRef(false);
  const geocoderRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBMORJwqAENHll476u4UXGJmV_bSFJycA8",
    libraries: GOOGLE_MAP_LIBRARIES,
  });

  const fileInputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const mapRef = useRef(null);

  const buttonStyle = {
    position: "absolute",
    top: -5,
    right: -7,
    background: "transparent",
    color: "#000",
    border: "1px solid #000",
    borderRadius: "50%",
    width: 16,
    height: 16,
    fontSize: 10,
    cursor: "pointer",
  };

  const validateField = (name, value) => {
    let errorMsg = "";
    if (value === undefined || value === null) return errorMsg;
    const strValue = String(value);
    switch (name) {
      case "name": if (!strValue.trim()) errorMsg = "Company Name is required"; break;
      case "phone":
        if (!strValue) errorMsg = "Phone number is required";
        else if (!/^[0-9]{10}$/.test(strValue)) errorMsg = "Phone number must be 10 digits";
        break;
      case "email":
        if (!strValue.trim()) errorMsg = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(strValue)) errorMsg = "Enter valid email address";
        break;
      case "website":
        if (strValue.trim() && !/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(strValue)) {
          errorMsg = "Enter valid website URL";
        }
        break;
      case "postal_code": if (!strValue) errorMsg = "Pincode is required"; break;
      case "pan":
        if (!strValue) errorMsg = "PAN is required";
        else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(strValue)) errorMsg = "Invalid PAN Number";
        break;
      case "gst":
        if (!strValue) errorMsg = "GST ID is required";
        else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(strValue))
          errorMsg = "Invalid GST Number";
        break;
      case "tin": if (!strValue.trim()) errorMsg = "TIN No is required"; break;
      case "fax": if (!strValue) errorMsg = "Fax Number is required"; break;
      case "established": if (!strValue) errorMsg = "Established Year is required"; break;
      case "description": if (!strValue.trim()) errorMsg = "Description is required"; break;
      case "address": if (!strValue.trim()) errorMsg = "Address is required"; break;
      case "country_id": if (!strValue) errorMsg = "Country field is required"; break;
      case "state_id": if (!strValue) errorMsg = "State field is required"; break;
      case "city_id": if (!strValue) errorMsg = "City field is required"; break;
      case "thumbnail":
        if (!value && !thumbnailPreview) errorMsg = "Thumbnail Image is required";
        break;
      case "image":
        if ((!Array.isArray(value) || value.length === 0) && (!Array.isArray(imagePreview) || imagePreview.length === 0)) {
          errorMsg = "Image is required";
        }
        break;
      default: break;
    }
    return errorMsg;
  };

  const fetchCountries = () => {
    get_country({ search: debouncedCountry })
      .then((res) => setCountries(res?.data || []))
      .catch(() => {});
  };

  const fetchStates = () => {
    if (form.country_id) {
      get_state({ country_id: form.country_id, search: debouncedState })
        .then((res) => setStates(res?.data || []))
        .catch(() => {});
    } else {
      setStates([]);
    }
  };

  const fetchCities = () => {
    if (form.state_id) {
      get_city({ state_id: form.state_id, search: debouncedCity })
        .then((res) => setCities(res?.data || []))
        .catch(() => {});
    } else {
      setCities([]);
    }
  };

  useEffect(() => { fetchCountries(); }, [debouncedCountry]);
  useEffect(() => { fetchStates(); }, [form.country_id, debouncedState]);
  useEffect(() => { fetchCities(); }, [form.state_id, debouncedCity]);

  // ── Geocode address as user types (skip if address was set by map/autocomplete) ──
  useEffect(() => {
    if (!isLoaded || !debouncedAddress || addressFromMapRef.current) {
      addressFromMapRef.current = false;
      return;
    }

    const geocoder = geocoderRef.current || new window.google.maps.Geocoder();
    geocoderRef.current = geocoder;

    geocoder.geocode({ address: debouncedAddress }, (results, status) => {
      if (status === "OK" && results[0]) {
        const lat = results[0].geometry.location.lat();
        const lng = results[0].geometry.location.lng();
        setForm((prev) => ({ ...prev, lat, lang: lng }));
        if (mapRef.current) {
          mapRef.current.panTo({ lat, lng });
          mapRef.current.setZoom(16);
        }
      }
    });
  }, [debouncedAddress, isLoaded]);

  const get_store_data = () => {
    get_vendor_store(user?.id)
      .then((res) => {
        const data = res?.data;
        if (!data) return;
        setHasStore(true);
        const countryId = data?.country?.id || data?.state?.country_id || "";
        if (data.state) setStates([data.state]);
        if (data.city) setCities([data.city]);
        const lat = data?.lat ? Number(data.lat) : null;
        const lng = data?.lang ? Number(data.lang) : null;
        setForm((prev) => ({
          ...prev,
          name: data.name || "",
          phone: data.phone || "",
          email: data.email || "",
          website: data.website || "",
          postal_code: data.postal_code || "",
          description: data.description || "",
          state: data.state?.id || "",
          city: data.city?.id || "",
          gst: data?.gst || "",
          pan: data?.pan || "",
          instagram: data?.instagram || "",
          facebook: data?.facebook || "",
          x: data?.x || "",
          youtube: data?.youtube || "",
          lat: data?.lat || "",
          lang: data?.lang || "",
          address: data?.address || "",
          tin: data?.tax_number || "",
          fax: data?.fax || "",
          established: data?.estimate_date || "",
          country_id: countryId,
          state_id: data?.state?.id || "",
          city_id: data?.city?.id || "",
          image: [],
          thumbnail: null,
        }));
        if (data.thumbnail) setThumbnailPreview(data.thumbnail);
        if (Array.isArray(data.image)) setImagePreview(data.image);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (user?.id) get_store_data();
  }, [user?.id]);

  const handleChange = (e) => {
    let { name, value, files } = e.target;
    if (name === "image" && files) {
      const fileArray = Array.from(files);
      const previewUrls = fileArray.map((file) => URL.createObjectURL(file));
      setForm((prev) => ({ ...prev, image: [...(prev.image || []), ...fileArray] }));
      setImagePreview((prev) => [...prev, ...previewUrls]);
      return;
    }
    setForm((prev) => ({ ...prev, [name]: value }));
    const errorMsg = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  // ── Handle manual address typing: allow full erase and re-type ──
  const handleAddressChange = (e) => {
    const value = e.target.value;
    addressFromMapRef.current = false; // User is typing, so allow geocoding
    setForm((prev) => ({ ...prev, address: value }));
    setErrors((prev) => ({ ...prev, address: value.trim() ? "" : "Address required" }));

    // If address is cleared, reset lat/lng
    if (!value.trim()) {
      setForm((prev) => ({ ...prev, lat: "", lang: "" }));
    }
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({ ...prev, thumbnail: file }));
      setThumbnailPreview(URL.createObjectURL(file));
      setErrors((prev) => ({ ...prev, thumbnail: "" }));
    }
  };

  const removeImage = (index) => {
    setImagePreview((prev) => prev.filter((_, i) => i !== index));
    setForm((prev) => ({ ...prev, image: prev.image.filter((_, i) => i !== index) }));
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const onLoadMap = (map) => { mapRef.current = map; };
  const onLoadAutocomplete = (autocomplete) => { autocompleteRef.current = autocomplete; };

  // ── Google Places Autocomplete selection ──
  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry) return;
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    addressFromMapRef.current = true; // came from autocomplete, skip type-geocode
    setForm((prev) => ({ ...prev, address: place.formatted_address, lat, lang: lng }));
    if (mapRef.current) {
      mapRef.current.panTo({ lat, lng });
      mapRef.current.setZoom(16);
    }
    setErrors((prev) => ({ ...prev, address: "" }));
  };

  // ── Drag handlers: DOM-direct mutations for frame-perfect pin animation ──
  const handleDragStart = () => {
    if (pinRef.current) {
      pinRef.current.style.transform = "translate(-50%, -100%) translateY(-12px) scale(1.18)";
      pinRef.current.style.filter = "drop-shadow(0 12px 18px rgba(0,0,0,0.38))";
    }
    if (shadowRef.current) {
      shadowRef.current.style.transform = "scaleX(0.5) scaleY(0.4)";
      shadowRef.current.style.opacity = "0.35";
    }
  };

  const handleDragEnd = () => {
    if (pinRef.current) {
      pinRef.current.style.transform = "translate(-50%, -100%) translateY(0px) scale(1)";
      pinRef.current.style.filter = "drop-shadow(0 4px 8px rgba(0,0,0,0.28))";
    }
    if (shadowRef.current) {
      shadowRef.current.style.transform = "scaleX(1) scaleY(1)";
      shadowRef.current.style.opacity = "0.25";
    }

    if (!mapRef.current) return;
    const center = mapRef.current.getCenter();
    const lat = center.lat();
    const lng = center.lng();
    addressFromMapRef.current = true;
    setForm((prev) => ({ ...prev, lat, lang: lng }));

    const geocoder = geocoderRef.current || new window.google.maps.Geocoder();
    geocoderRef.current = geocoder;
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        addressFromMapRef.current = true;
        setForm((prev) => ({ ...prev, address: results[0].formatted_address }));
        setErrors((prev) => ({ ...prev, address: "" }));
      }
    });
  };

  // ── Sync map with form coordinates (initial load / manual typing) ──
  useEffect(() => {
    if (isLoaded && mapRef.current && form.lat && form.lang) {
      if (!addressFromMapRef.current) {
        mapRef.current.panTo({ lat: Number(form.lat), lng: Number(form.lang) });
      }
      addressFromMapRef.current = false;
    }
  }, [isLoaded, form.lat, form.lang]);

  // ── Navigate based on get_profile flags after successful save ──
  const navigateAfterSave = async () => {
    try {
      const profileRes = await get_profile();
      const profileData = profileRes?.data;
      const isVendor = profileData?.is_vendor === 1;
      const isService = profileData?.is_services === 1;
      if (isVendor) {
        navigate("/dashboard/add-material");
      } else if (isService) {
        navigate("/dashboard/add-service");
      }
    } catch (err) {}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};
    Object.keys(form).forEach((key) => {
      const err = validateField(key, form[key]);
      if (err) newErrors[key] = err;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstError = Object.values(newErrors)[0];
      toast.error(firstError);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: form.name,
        city: form.city_id,
        state: form.state_id,
        country: form.country_id,
        postal_code: form.postal_code,
        phone: form.phone,
        email: form.email,
        website: form.website,
        description: form.description,
        gst: form.gst,
        pan: form.pan,
        instagram: form.instagram,
        facebook: form.facebook,
        x: form.x,
        youtube: form.youtube,
        lat: form.lat,
        lang: form.lang,
        address: form.address,
        fax: form.fax,
        tax_number: form.tin,
        estimate_date: form.established,
        image: form.image,
        thumbnail: form.thumbnail,
        user_id: user?.id,
      };

      if (hasStore) {
        await vendor_store_edit(payload);
        toast.success("Company Profile updated successfully");
      } else {
        await vendor_store(payload);
        toast.success("Company Profile created successfully");
      }

      await navigateAfterSave();
    } catch (err) {
      if (err?.response?.data?.errors) {
        const backendErrors = err.response.data.errors;
        const mappedErrors = {};
        const keyMapping = {
          city: "city_id",
          state: "state_id",
          country: "country_id",
          tax_number: "tin",
          estimate_date: "established",
        };
        Object.keys(backendErrors).forEach((key) => {
          const frontendKey = keyMapping[key] || key;
          mappedErrors[frontendKey] = Array.isArray(backendErrors[key])
            ? backendErrors[key][0]
            : backendErrors[key];
        });
        setErrors(mappedErrors);
        toast.error("Validation failed. Please check the form.");
      } else {
        toast.error(err?.response?.data?.message || "Failed to save");
      }
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = { width: "100%", height: "300px" };
  const defaultCenter = { lat: 10.99835602, lng: 77.01502627 };

  const currentCenter = form.lat && form.lang
    ? { lat: Number(form.lat), lng: Number(form.lang) }
    : defaultCenter;

  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col xl={12} lg={12} md={12} sm={12}>
          <div className="card shadow-sm border-1 rounded-4">
            <div
              className="card-header text-center text-white d-flex justify-content-between align-items-center py-3 border-1"
              style={{ backgroundColor: "#6A8F3E" }}
            >
              <h5 className="mb-0" style={{ fontWeight: 500 }}>Company Profile</h5>
              {hasStore && (
                <Button
                  variant="light"
                  size="sm"
                  onClick={() => navigate(`/material-store/detail/${user?.id}`)}
                  style={{ color: "#6A8F3E", fontWeight: 600 }}
                >
                  View My Shop
                </Button>
              )}
            </div>

            <div className="card-body p-4">
              <Form onSubmit={handleSubmit}>
                <Row className="g-4">

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Company Name <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="name" value={form.name} onChange={handleChange} placeholder="Enter Name" isInvalid={!!errors.name} />
                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Phone Number <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="phone" value={form.phone} type="number" onChange={handleChange} placeholder="Enter phone number" isInvalid={!!errors.phone} />
                    <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Email Address <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="email" value={form.email} onChange={handleChange} placeholder="Enter email" isInvalid={!!errors.email} />
                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Website URL</Form.Label>
                    <Form.Control name="website" value={form.website} onChange={handleChange} placeholder="https://example.com" isInvalid={!!errors.website} />
                    <Form.Control.Feedback type="invalid">{errors.website}</Form.Control.Feedback>
                  </Col>

                  {/* Country */}
                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Country <span style={{ color: "red" }}>*</span></Form.Label>
                    <Autocomplete
                      options={countries}
                      getOptionLabel={(option) => option.country_name || ""}
                      openOnFocus
                      autoHighlight
                      filterOptions={(x) => x}
                      value={countries.find((o) => o.id === form.country_id) || null}
                      onChange={(event, newValue) => {
                        setForm((prev) => ({ ...prev, country_id: newValue ? newValue.id : "", state_id: "", city_id: "" }));
                        setErrors((prev) => ({ ...prev, country_id: newValue ? "" : "Country field is required", state_id: "", city_id: "" }));
                      }}
                      onInputChange={(event, newInputValue) => setCountrySearch(newInputValue)}
                      renderInput={(params) => (
                        <MuiTextField {...params} size="small" placeholder="Select Country" error={!!errors.country_id} helperText={errors.country_id}
                          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", backgroundColor: "#fff" } }}
                        />
                      )}
                    />
                  </Col>

                  {/* State */}
                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>State <span style={{ color: "red" }}>*</span></Form.Label>
                    <Autocomplete
                      options={states}
                      getOptionLabel={(option) => option.state_name || ""}
                      disabled={!form.country_id}
                      openOnFocus
                      autoHighlight
                      filterOptions={(x) => x}
                      value={states.find((o) => o.id === form.state_id) || null}
                      onChange={(event, newValue) => {
                        setForm((prev) => ({ ...prev, state_id: newValue ? newValue.id : "", city_id: "" }));
                        setErrors((prev) => ({ ...prev, state_id: newValue ? "" : "State field is required", city_id: "" }));
                      }}
                      onInputChange={(event, newInputValue) => setStateSearch(newInputValue)}
                      renderInput={(params) => (
                        <MuiTextField {...params} size="small" placeholder="Select State" error={!!errors.state_id} helperText={errors.state_id}
                          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", backgroundColor: "#fff" } }}
                        />
                      )}
                    />
                  </Col>

                  {/* City */}
                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>City <span style={{ color: "red" }}>*</span></Form.Label>
                    <Autocomplete
                      options={cities}
                      getOptionLabel={(option) => option.city_name || ""}
                      disabled={!form.state_id}
                      openOnFocus
                      autoHighlight
                      filterOptions={(x) => x}
                      value={cities.find((o) => o.id === form.city_id) || null}
                      onChange={(event, newValue) => {
                        setForm((prev) => ({ ...prev, city_id: newValue ? newValue.id : "" }));
                        setErrors((prev) => ({ ...prev, city_id: newValue ? "" : "City field is required" }));
                      }}
                      onInputChange={(event, newInputValue) => setCitySearch(newInputValue)}
                      renderInput={(params) => (
                        <MuiTextField {...params} size="small" placeholder="Select City" error={!!errors.city_id} helperText={errors.city_id}
                          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", backgroundColor: "#fff" } }}
                        />
                      )}
                    />
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Postal Code <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="postal_code" value={form.postal_code} placeholder="e.g 6XX XXX" onChange={handleChange} isInvalid={!!errors.postal_code} />
                    <Form.Control.Feedback type="invalid">{errors.postal_code}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Instagram Link</Form.Label>
                    <Form.Control name="instagram" value={form.instagram} onChange={handleChange} isInvalid={!!errors.instagram} />
                    <Form.Control.Feedback type="invalid">{errors.instagram}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>X Link</Form.Label>
                    <Form.Control name="x" value={form.x} onChange={handleChange} isInvalid={!!errors.x} />
                    <Form.Control.Feedback type="invalid">{errors.x}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Youtube Link</Form.Label>
                    <Form.Control name="youtube" value={form.youtube} onChange={handleChange} isInvalid={!!errors.youtube} />
                    <Form.Control.Feedback type="invalid">{errors.youtube}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Facebook Link</Form.Label>
                    <Form.Control name="facebook" value={form.facebook} onChange={handleChange} placeholder="https://facebook.com/..." />
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Pan Number <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="pan" value={form.pan} onChange={handleChange} isInvalid={!!errors.pan} />
                    <Form.Control.Feedback type="invalid">{errors.pan}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Gst Number <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="gst" value={form.gst} placeholder="e.g. 22AAAAA0000A1Z5" onChange={handleChange} isInvalid={!!errors.gst} />
                    <Form.Control.Feedback type="invalid">{errors.gst}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Tax Id No (TIN) <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="tin" value={form.tin} placeholder="e.g. 3312345678901" onChange={handleChange} isInvalid={!!errors.tin} />
                    <Form.Control.Feedback type="invalid">{errors.tin}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Fax Number <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control name="fax" value={form.fax} type="text" placeholder="e.g +91 44 23456789" onChange={handleChange} isInvalid={!!errors.fax} />
                    <Form.Control.Feedback type="invalid">{errors.fax}</Form.Control.Feedback>
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Year Established <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control type="text" name="established" placeholder="Enter Year" value={form.established} onChange={handleChange} isInvalid={!!errors.established} min="1900" />
                    <Form.Control.Feedback type="invalid">{errors.established}</Form.Control.Feedback>
                  </Col>

                  {/* ── Address + Map Section ── */}
                  <Col xs={12} md={12}>
                    <Form.Group className="mb-1">
                      <Form.Label style={{ fontWeight: 500 }}>
                        Address <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      {isLoaded ? (
                        <>
                          <GMapAutocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged}>
                            <Form.Control
                              placeholder="Type address or drag the pin below"
                              value={form.address}
                              onChange={handleAddressChange}
                              isInvalid={!!errors.address}
                              style={{ borderRadius: 6 }}
                            />
                          </GMapAutocomplete>
                          <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                        </>
                      ) : (
                        <Form.Control placeholder="Loading map..." disabled />
                      )}
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={12}>
                    {/* Inject CSS for butter-smooth pin transitions */}
                    <style>{`
                      .map-pin-svg {
                        transition: transform 0.15s cubic-bezier(0.34, 1.56, 0.64, 1),
                                    filter 0.15s ease;
                        transform: translate(-50%, -100%) translateY(0px) scale(1);
                        filter: drop-shadow(0 4px 8px rgba(0,0,0,0.28));
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        pointer-events: none;
                        z-index: 2;
                        transform-origin: bottom center;
                      }
                      .map-pin-shadow {
                        transition: transform 0.15s cubic-bezier(0.34, 1.56, 0.64, 1),
                                    opacity 0.15s ease;
                        transform: scaleX(1) scaleY(1);
                        opacity: 0.25;
                        width: 14px;
                        height: 5px;
                        background: rgba(0,0,0,0.35);
                        border-radius: 50%;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        margin-left: -7px;
                        margin-top: -2px;
                        pointer-events: none;
                        z-index: 1;
                      }
                      .map-hint {
                        transition: opacity 0.3s ease;
                        opacity: 1;
                      }
                    `}</style>

                    {isLoaded ? (
                      <div style={{ position: "relative", width: "100%", height: "380px", borderRadius: 10, overflow: "hidden", border: "1.5px solid #dee2e6", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>

                        <GoogleMap
                          mapContainerStyle={{ width: "100%", height: "100%" }}
                          defaultCenter={currentCenter}
                          zoom={form.lat && form.lang ? 16 : 14}
                          onLoad={onLoadMap}
                          onDragStart={handleDragStart}
                          onDragEnd={handleDragEnd}
                          options={{
                            zoomControl: true,
                            zoomControlOptions: { position: 7 }, // RIGHT_CENTER
                            streetViewControl: false,
                            mapTypeControl: false,
                            fullscreenControl: false,
                            gestureHandling: "greedy",
                            clickableIcons: false,
                          }}
                        />

                        {/* ── Pin SVG — animated via DOM ref, never re-renders ── */}
                        <div ref={pinRef} className="map-pin-svg">
                          <svg
                            width="44"
                            height="44"
                            viewBox="0 0 44 44"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {/* Pin body */}
                            <path
                              d="M22 4C15.373 4 10 9.373 10 16C10 25 22 40 22 40C22 40 34 25 34 16C34 9.373 28.627 4 22 4Z"
                              fill="#E74C3C"
                              stroke="white"
                              strokeWidth="1.5"
                            />
                            {/* White inner circle */}
                            <circle cx="22" cy="16" r="5" fill="white" />
                            {/* Inner red dot */}
                            <circle cx="22" cy="16" r="2.5" fill="#E74C3C" />
                          </svg>
                        </div>

                        {/* ── Shadow ellipse under pin ── */}
                        <div ref={shadowRef} className="map-pin-shadow" />
                      </div>
                    ) : (
                      <div style={{ height: 380, display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5", borderRadius: 10 }}>
                        <CircularProgress size={28} style={{ color: "#6A8F3E" }} />
                        <span style={{ marginLeft: 10, color: "#888" }}>Loading Map...</span>
                      </div>
                    )}
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 600, display: "block" }}>Image <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control type="file" multiple name="image" accept=".png, .jpg, .jpeg .jfif" onChange={handleChange} ref={fileInputRef} isInvalid={!!errors.image} />
                    <Form.Control.Feedback type="invalid">{errors.image}</Form.Control.Feedback>
                    {imagePreview.length > 0 && (
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {imagePreview.map((src, index) => (
                          <div key={index} style={{ position: "relative" }}>
                            <img src={src} width={60} height={60} style={{ borderRadius: 4, objectFit: "cover" }} alt="preview" />
                            <button type="button" onClick={() => removeImage(index)} style={buttonStyle}>✕</button>
                          </div>
                        ))}
                      </div>
                    )}
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 600, display: "block" }}>Thumbnail Image <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control type="file" accept=".png,.jpg,.jpeg,.jfif" onChange={handleThumbnailChange} isInvalid={!!errors.thumbnail} />
                    <Form.Control.Feedback type="invalid">{errors.thumbnail}</Form.Control.Feedback>
                    {thumbnailPreview && (
                      <Box mt={2} display="flex" justifyContent="center">
                        <img src={thumbnailPreview} alt="thumbnail preview" style={{ width: 120, height: 120, borderRadius: 8, objectFit: "cover", border: "1px solid #ddd" }} />
                      </Box>
                    )}
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label style={{ fontWeight: 500 }}>Brief Description <span style={{ color: "red" }}>*</span></Form.Label>
                    <Form.Control as="textarea" rows={3} name="description" value={form.description} onChange={handleChange} isInvalid={!!errors.description} />
                    <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
                  </Col>

                  <Col md={12} className="text-center">
                    <Button
                      type="submit"
                      className="px-5 py-2"
                      style={{ backgroundColor: "#6A8F3E", borderColor: "#6A8F3E", fontWeight: 500 }}
                    >
                      {loading ? <CircularProgress size={22} sx={{ color: "white" }} /> : "Save Profile"}
                    </Button>
                  </Col>

                </Row>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}